// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[4].use[1]!../../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[4].use[2]!../../styles/common.module.css");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loop-button_button__\\+kyW7 {
}

.loop-button_active__NJ1d2 {
}
`, "",{"version":3,"sources":["webpack://./src/components/loop-button/loop-button.module.css"],"names":[],"mappings":"AAAA;AAEA;;AAEA;AAEA","sourcesContent":[".button {\n  composes: button from '../../styles/common.module.css';\n}\n\n.active {\n  composes: active from '../../styles/common.module.css';\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `loop-button_button__+kyW7 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["button"]}`,
	"active": `loop-button_active__NJ1d2 ${___CSS_LOADER_ICSS_IMPORT_0___.locals["active"]}`
};
module.exports = ___CSS_LOADER_EXPORT___;
